"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
exports.OsmosysOverlay = ({ children, rounded, opacity = 0.75, white = false, onClick, border, }) => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysOverlay.outer", className: ['position-absolute'], style: { bottom: 0, left: 0, right: 0, top: 0, zIndex: 120 } },
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysOverlay.inner", className: "position-relative w-100 h-100" },
            react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysOverlay.foreground", className: "position-absolute w-100 h-100", style: { bottom: 0, left: 0, right: 0, top: 0, zIndex: 112 }, flexColCenteredFilled: true },
                react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysOverlay.foreground.inner", flexRowCentered: true }, children)),
            react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysOverlay.background", className: [
                    'position-absolute',
                    white ? 'bg-white' : 'bg-dark',
                    'w-100 h-100',
                    border === 'primary' && 'border border-primary',
                ], onClick: onClick, rounded: rounded, style: {
                    bottom: 0,
                    left: 0,
                    opacity,
                    right: 0,
                    top: 0,
                    zIndex: 111,
                } }))));
};
//# sourceMappingURL=OsmosysOverlay.js.map